// Campus photo for /colleges/loyola-university-chicago: CC BY 3.0, by Amerique, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACudahy_Hall%2C_Madonna_della_Strada_Chapel.JPG), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/loyola-university-chicago/; credited under the photo.
const photo = {
    "slug": "loyola-university-chicago",
    "alt": "Cudahy Science Hall and Madonna della Strada Chapel beside Lake Michigan on Loyola University Chicago's Lake Shore Campus",
    "src": "/colleges/loyola-university-chicago/campus-1600.webp",
    "srcSmall": "/colleges/loyola-university-chicago/campus-800.webp",
    "srcMid": "/colleges/loyola-university-chicago/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/loyola-university-chicago/og.jpg",
    "title": "Cudahy Hall, Madonna della Strada Chapel",
    "author": "Amerique",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACudahy_Hall%2C_Madonna_della_Strada_Chapel.JPG",
    "read": "2026-10-01"
};

export default photo;
